import { Child } from 'types';
import { useChildAbilities } from 'abilities';
import { useChildrenDetailsPath } from 'hooks/useChildrenDetailsPath/useChildrenDetailsPath';
import { FirstAndLastNameDisplay } from 'components/molecules/Table/FirstAndLastNameDisplay/FirstAndLastNameDisplay';

type ChildFirstAndLastNameDisplayProps = Pick<Child, 'firstName' | 'lastName'> &
    Partial<Pick<Child, 'id'>>;

export const ChildFirstAndLastNameDisplay = ({
    id,
    firstName,
    lastName,
}: ChildFirstAndLastNameDisplayProps) => {
    const { getChildrenDetailsPath } = useChildrenDetailsPath();
    const { childAbilities } = useChildAbilities();

    const canViewChildDetails = childAbilities.checkIfCanViewChildrenList();

    const childDetailsPath = id ? getChildrenDetailsPath('', id) : undefined;
    const to = canViewChildDetails && id ? childDetailsPath : undefined;

    return <FirstAndLastNameDisplay firstName={firstName} lastName={lastName} to={to} />;
};
